function About() {

  return (
      <section className="about-page">
        <div>
          
        </div>
      </section>
  );
}

export default About;

